<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="77px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="小组名称">
              <el-select clearable filterable class="ele-block" v-model="where.id" placeholder="请选择">
                <el-option v-for="item in classList" :key="item.id" :value="item.id" :label="item.classname" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)"
            v-if="permission.includes('sys:class:add')">添加</el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon"
            :disabled="!selection.length" @click="removeBatch"
            v-if="permission.includes('sys:class:dall')">删除</el-button>
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon"
            @click="initData" v-if="permission.includes('sys:class:edit')">初始化</el-button>
        </template>

        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openBind(row)"
            v-if="permission.includes('sys:class:edit')">绑定</el-button>
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
            v-if="permission.includes('sys:class:edit')">编辑</el-button>
          <el-popconfirm class="ele-action" title="确定要删除此数据吗？" @confirm="remove(row)"
            v-if="permission.includes('sys:class:delete')">
            <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>

        <template slot="type_code" slot-scope="{ row }">
          <dict-tag dict-code="type_name" :value="row.type_code" />
        </template>
        <template slot="status" slot-scope="{ row }">
          <el-switch v-model="row.status" @change="editStatus(row)" :active-value="1" :inactive-value="2"
            v-if="permission.includes('sys:class:status')" />
        </template>
      </ele-pro-table>
    </el-card>

    <reclass-edit :data="current" :visible.sync="showEdit" @done="reload" />
    <reclass-bind-dialog :row-data="bindRow" :visible.sync="showBind" @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReclassEdit from './reclass-edit';
import ReclassBindDialog from './reclass-bind-dialog';

export default {
  name: 'Resourceclass',
  components: { ReclassEdit, ReclassBindDialog },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/resourceclass/index',
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { prop: 'classname', label: '小组名称', showOverflowTooltip: true, minWidth: 120, align: 'center' },
        { prop: 'bot_group_name', label: '群组名称', showOverflowTooltip: true, minWidth: 140, align: 'center' },
        { prop: 'bot_group_id', label: '群组ID', showOverflowTooltip: true, minWidth: 140, align: 'center' },
        { prop: 'country_name', label: '货币国家', showOverflowTooltip: true, minWidth: 120, align: 'center' },
        { prop: 'type_code', label: '渠道类型', minWidth: 100, align: 'center', slot: 'type_code' },
        { prop: 'day_count', label: '总余额', showOverflowTooltip: true, minWidth: 120, align: 'center' },
        { prop: 'status', label: '小组状态', align: 'center', width: 100, resizable: false, slot: 'status' },
        {
          prop: 'create_time', label: '创建时间', sortable: 'custom', showOverflowTooltip: true, minWidth: 120, align: 'center',
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        {
          prop: 'update_time', label: '更新时间', sortable: 'custom', showOverflowTooltip: true, minWidth: 120, align: 'center',
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        },
        { columnKey: 'action', label: '操作', width: 220, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false,
      bindRow: null,
      showBind: false,
      classList: []
    };
  },
  mounted() {
    this.queryClass();
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    queryClass() {
      this.$http.get('/Resourceclass/getClassList', { params: { lite: 1 } }).then((res) => {
        if (res.data.code === 0) {
          this.classList = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    openBind(row) {
      this.bindRow = row;
      this.showBind = true;
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/resourceclass/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的数据吗?', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/resourceclass/delete', {
          id: this.selection.map((d) => d.id)
        }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    initData() {
      this.$confirm('初始化将清空全部小组数据且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/resourceclass/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.selection = [];
            this.queryClass();
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/resourceclass/status', {
        id: row.id,
        status: row.status
      }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = row.status === 1 ? 2 : 1;
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        row.status = row.status === 1 ? 2 : 1;
        this.$message.error(e.message);
      });
    }
  }
};
</script>
